import React from 'react';
import camelCase from 'lodash/camelCase';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { deploymentPreconditionRelayResource } from '@atlassian/jira-router-resources-software-deployments/src/services/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { softwareDeploymentsNextGenRoute } from '@atlassian/jira-router-routes-software-deployments-routes/src/softwareDeploymentsNextGenRoute.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { LazyDeployments } from './common/deployments-old.tsx';
import { softwareDeploymentsPageEntrypoint } from './common/deployments.tsx';

const DeploymentsNextGen = () => (
	<LazyPage Page={LazyDeployments} pageId="deploymentsNextGen" shouldShowSpinner />
);

const getHorizontalNavResource = () =>
	fg('migrate-deployments-to-entry-points') ? [] : [horizontalNavJiraResource];

export const softwareDeploymentsNextGenRouteEntry = createEntry(
	softwareDeploymentsNextGenRoute,
	() => ({
		group: 'software',
		component: fg('migrate-deployments-to-entry-points')
			? undefined
			: componentWithCondition(
					isDevopsFeatureDisabledInFedRamp,
					ErrorPagesNotFound,
					DeploymentsNextGen,
				),
		layout: softwareProjectLayoutNoOnboarding,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarNextGen,
			horizontal: AsyncHorizontalNavJira,
			onlyShowHorizontalOnNav4: true,
		},
		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getHorizontalNavResource(),
			// end of resources expanded from getNavigationSidebarProjectResource
			deploymentPreconditionRelayResource,
			projectContextResource,
		],
		forPaint: fg('migrate-deployments-to-entry-points')
			? undefined
			: [LazyAtlassianNavigation, LazyDeployments],
		entryPoint: () => {
			if (fg('migrate-deployments-to-entry-points')) {
				return isDevopsFeatureDisabledInFedRamp()
					? notFoundPageEntrypoint
					: softwareDeploymentsPageEntrypoint;
			}
			return undefined;
		},
		meta: {
			reporting: {
				id: 'software-deployments',
				packageName: camelCase('software-deployments'),
				teamName: 'fusion-solaris',
			},
		},
	}),
);
